import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldX } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fitsmith-academy/artifacts/zbh0gz3y_291E0B11-36FD-4420-BAF1-DDEC0FEFC105.png";

export default function RestitutiebeleidPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#080808]">
      {/* Header */}
      <div className="border-b border-white/5 px-4 py-4">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate(-1)}
            className="w-8 h-8 rounded-xl bg-[#141414] border border-white/6 flex items-center justify-center text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft size={16} />
          </button>
          <div className="flex items-center gap-2">
            <img src={LOGO_URL} alt="FitSmith" className="h-7 w-7 object-contain" />
            <span className="text-white font-bold tracking-wide">FitSmith</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-14">
        {/* Titel */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-xl bg-[#C9A84C]/10 border border-[#C9A84C]/20 flex items-center justify-center shrink-0">
            <ShieldX size={20} className="text-[#C9A84C]" />
          </div>
          <div>
            <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-[3px] mb-1">Juridisch</p>
            <h1 className="text-white font-bold text-3xl sm:text-4xl">Restitutiebeleid</h1>
          </div>
        </div>

        <div className="space-y-8 text-zinc-300 text-base leading-relaxed">
          {/* Intro */}
          <div className="bg-[#0f0f0f] border border-white/8 rounded-2xl p-6">
            <p>
              Bij FitSmith bieden wij digitale producten en diensten aan. Na aankoop en levering van het product is restitutie niet mogelijk.
            </p>
          </div>

          {/* Akkoord bij aankoop */}
          <div>
            <h2 className="text-white font-bold text-xl mb-4">Door een aankoop te doen, ga je akkoord met het volgende:</h2>
            <div className="space-y-3">
              {[
                "Je ontvangt direct toegang tot het digitale product",
                "Je ziet af van je wettelijke herroepingsrecht van 14 dagen",
                "Aangekochte producten kunnen niet worden geretourneerd of terugbetaald",
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3 bg-[#0f0f0f] border border-white/6 rounded-xl px-5 py-4">
                  <div className="w-5 h-5 rounded-full bg-[#C9A84C]/15 border border-[#C9A84C]/30 flex items-center justify-center shrink-0 mt-0.5">
                    <span className="text-[#C9A84C] text-[10px] font-black">{i + 1}</span>
                  </div>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Uitzonderingen */}
          <div>
            <h2 className="text-white font-bold text-xl mb-4">Uitzonderingen</h2>
            <div className="bg-[#0f0f0f] border border-[#C9A84C]/15 rounded-2xl px-6 py-5">
              <p>
                Alleen in het geval van een technisch probleem waarbij het product niet geleverd kan worden en dit niet opgelost kan worden, kan een passende oplossing worden geboden.
              </p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-white font-bold text-xl mb-4">Contact</h2>
            <div className="bg-[#0f0f0f] border border-white/8 rounded-2xl px-6 py-5 flex items-center gap-3">
              <p>Voor vragen kun je contact opnemen via:{" "}
                <a href="mailto:info@fitsmith.nl" className="text-[#C9A84C] hover:underline font-semibold">
                  info@fitsmith.nl
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Terug knop */}
        <button onClick={() => navigate(-1)}
          className="mt-12 flex items-center gap-2 text-zinc-500 hover:text-[#C9A84C] text-sm transition-colors">
          <ArrowLeft size={14} /> Terug
        </button>
      </div>

      {/* Footer */}
      <div className="border-t border-white/5 py-6 text-center">
        <p className="text-zinc-700 text-xs">© 2026 FitSmith. Alle rechten voorbehouden.</p>
      </div>
    </div>
  );
}
